import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AppSimpleSelector = /*#__PURE__*/function (_Vue) {
  _inherits(AppSimpleSelector, _Vue);

  var _super = _createSuper(AppSimpleSelector);

  function AppSimpleSelector() {
    var _this;

    _classCallCheck(this, AppSimpleSelector);

    _this = _super.apply(this, arguments);
    _this.model = '';
    return _this;
  }

  _createClass(AppSimpleSelector, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value === -1 ? '' : this.items[this.value];
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val) {
      this.model = val === -1 ? '' : this.items[val];
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler(val, index) {
      this.model = val;
      return index;
    }
  }, {
    key: "onItemsChanged",
    value: function onItemsChanged(val) {
      this.model = this.value === -1 ? '' : val[this.value];
    }
  }, {
    key: "submit",
    value: function submit() {}
  }]);

  return AppSimpleSelector;
}(Vue);

__decorate([Prop(Number)], AppSimpleSelector.prototype, "value", void 0);

__decorate([Prop(String)], AppSimpleSelector.prototype, "label", void 0);

__decorate([Prop({
  type: String
})], AppSimpleSelector.prototype, "placeholder", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 289
})], AppSimpleSelector.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppSimpleSelector.prototype, "height", void 0);

__decorate([Prop({
  type: Array
})], AppSimpleSelector.prototype, "items", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], AppSimpleSelector.prototype, "isShowAll", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSimpleSelector.prototype, "disabled", void 0);

__decorate([Watch('value')], AppSimpleSelector.prototype, "onValueChanged", null);

__decorate([Emit('input')], AppSimpleSelector.prototype, "valueChangedHandler", null);

__decorate([Watch('items')], AppSimpleSelector.prototype, "onItemsChanged", null);

__decorate([Emit()], AppSimpleSelector.prototype, "submit", null);

AppSimpleSelector = __decorate([Component], AppSimpleSelector);
export default AppSimpleSelector;